import Colors from '@/constants/Colors';
import { Card } from 'antd';
import styled from 'styled-components';

export const StyledPaymentForm = styled.div`
  width: 100%;

  h3 {
    color: inherit;
  }

  .text-right {
    text-align: right;
  }

  .info {
    font-size: 15px;
    color: ${Colors.lightGray};
    cursor: pointer;
  }

  .total {
    font-size: 20px;
    .amount {
      font-size: 22px;
      margin-left: 10px;
    }

    &.big {
      font-size: 20px;
      .amount {
        font-size: 28px;
      }
    }
  }

  .form-loader {
    width: 100%;
    margin-top: 20px;
    text-align: center;
  }

  .quantity-unit-text {
    width: 140px;
    display: inline-block;
    margin-right: 10px;
    text-align: left;
    font-size: 20px;

    .price {
      font-weight: bold;
    }
  }

  .quantity-unit-select {
    flex-grow: 1;
    text-transform: capitalize;
  }

  .total-container {
    align-items: center;
    .total-label {
      font-size: 20px;
    }

    .discount-alert {
      margin-top: 32px;
      margin-bottom: 20px;
    }
  }

  .ant-typography.ant-typography-secondary {
    color: ${Colors.lightGray};
  }

  .alert-message {
    width: 100%;
  }
`;

export const CustomCard = styled(Card)`
  height: 100%;
  display: flex;
  border: none;

  &.bordered {
    border-radius: 10px;
    box-shadow: 0px 1px 4px ${Colors.boxShadowGray};
    border: 1px solid ${Colors.border};
  }

  &:not(.bordered) {
    > .ant-card-body {
      padding: 0;
    }
  }

  .ant-card-body {
    display: flex;
    gap: 20px;
    flex-grow: 1;

    .left-panel,
    .right-panel {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .quantity-unit-options {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .quantity-unit-option {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        border-radius: 10px;
        border: 2px solid ${Colors.border};
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          box-shadow: ${Colors.boxShadow};
        }

        &.active {
          box-shadow: ${Colors.boxShadow};
          background-color: ${Colors.backgroundPaleBlue};
          border: 2px solid ${Colors.primary};
        }

        .quantity-unit-buttons {
          display: flex;
          gap: 20px;

          .quantity-unit-value {
            font-size: 20px;
          }
        }
      }
    }
  }
`;
